import React, { useEffect } from "react";
import logo from '../../assets/logo-full.webp';
import { FaArrowRight } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import "../../styles/marketing.css"

const HeaderWebMarketing = ({ hideRight = false }) => {
    const navigate = useNavigate();
    return (
        <nav>
            <div className="navbar-content">
                <div className="left-section">
                    <button className="unoutlined-button"
                        onClick={() => navigate("/")}>
                        <img src={logo} // Replace with your icon source
                            alt="icon"
                            className="icon-full"
                        />
                    </button>
                </div>
                {hideRight === true ? null :
                    <div className="right-section">
                        <button className="filled-button"
                            type='button'
                            onClick={(e) => {
                                window.open("https://web.conra.net", "_blank")
                            }}>
                            Get Started <FaArrowRight style={{ marginLeft: "6px" }} />
                        </button>
                    </div>
                }
            </div>
        </nav>
    );
};

export default HeaderWebMarketing;